import React from "react";
import DevelopBannerSection from "../components/Homepage/DevelopPageComponents/DevelopBannerSection";
import DevDiff from "../components/Homepage/DevelopPageComponents/DevDiff";
import { Accodion } from "../components/Accordion/AccordionItem";
import FaqVideo from "../components/FaqVideo/FaqVideo";
import TransparentRoundedBtn from "../components/CTA/TransparentRoundedBtn";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { float1, float2, sanyogprofileImg } from "../components";
import IndusExpert from "../components/IndustriesPageComponents/IndusExpert";
import HealthSliderCard from "../components/HealthcarePageComponent/HealthSliderCard";
import DevServicesBlocks from "../components/DevPageComponents/DevServicesBlocks";
import CaseStudyNew from "../components/Homepage/CaseStudy/CaseStudyNew";
function FirebaseDev() {

  var settings2 = {
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    autoplay: true,
    speed: 800,
    adaptiveHeight: false,
    infinite: true,
    useTransform: true,
    cssEase: "cubic-bezier(0.77, 0, 0.18, 1)",
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <>
      <div className="devlopPage" id="devlopPage">
        <div className="devTopSection firebaseBg">
          <DevelopBannerSection
            line1="Leading"
            line2="Offshore Firebase"
            line3="Development Solutions"
            BannerPara="Enlist certified Firebase developers from a leading offshore Firebase development company to construct swift and scalable Android, iOS, and web applications, backed by high-performance backend systems. Our established Firebase application development offerings underscore the proficiency of our developers in crafting custom chat solutions. "
          />
          <div className="shapeSvg">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15002 2408">
              <g id="Layer_x0020_1">
                <metadata id="CorelCorpID_0Corel-Layer" />
                <path
                  className="fil0"
                  d="M14999.66 160.41l0 2250.5 -15002 0 0 -2408.48c4.48,15.46 34.05,38.31 47.09,51.36 18.3,18.3 33.31,33.31 51.61,51.61l377.15 322.94c339.34,254.69 723.38,451.6 1129.12,576.25 740.24,227.38 1518.28,209.44 2250.74,-34.78 297.55,-99.2 684.02,-289.57 933.07,-476.11 87.62,-65.63 227.27,-165.69 307.34,-240.17 31.42,-29.23 114.35,-99.39 131.22,-124.58 20,4.66 99.59,47.55 124.17,59.83 42.41,21.2 81.55,40.72 122.67,61.33l125.61 58.39c133.82,59.52 249.76,112.63 391.76,169.22 238.34,95 587.91,216.82 832.54,284.94 200.63,55.86 382.28,106.97 590.69,154.3 1557.59,353.7 3775.68,425.94 5382.01,17.95 25.54,-6.48 49.29,-10.39 73.59,-16.17l373.43 -93.31c198.88,-54.19 343.18,-97.87 536.61,-159.02l312.66 -109.2c47.88,-17.88 90.5,-33.57 136.53,-51.96 82.88,-33.12 316.41,-125.5 392.57,-163.92l128.78 -59.7c23.6,-10.77 225.99,-115.13 251.04,-121.22z"
                />
              </g>
            </svg>
          </div>
        </div>
        <div className="healthServicesSliderWrap">
          <div className="container">
            <div className="row sectionFlexHeading">
              <div className="col-md-6 col-12">
                <div className="sectionTitle">
                  <h2>
                    Strategic Approach of a Leading Firebase App Development
                    Firm
                  </h2>
                </div>
              </div>
              <div className="col-md-6 col-12">
                <p className="sectionPara">
                  At Version Next Technologies, Our skilled team of developers
                  harnesses the power of Firebase to create cutting-edge
                  solutions that ensure seamless performance, real-time data
                  synchronization, and high-quality user experiences.
                </p>
              </div>
            </div>
            <div className="healthServicesSlider">
              <Slider {...settings2} className="slider-with-gap">
                <div className="slide-item">
                  <HealthSliderCard
                    cardTitle="Mobile App Development with Firebase Integration"
                    cardPara="We specialize in creating value-oriented Android, iOS, and cross-platform applications, integrating them with Google Firebase to elevate quality and enhance user experiences."
                    cardLink=""
                    btnName=" Leave a request"
                  />
                </div>
                <div className="slide-item">
                  <HealthSliderCard
                    cardTitle="Development of Web Applications with Firebase Integration"
                    cardPara="Firebase empowers the creation of rapid, secure, scalable, and high-performance websites, offering streamlined authentication and swift implementation."
                    cardLink=""
                    btnName="Get consultation"
                  />
                </div>
                <div className="slide-item">
                  <HealthSliderCard
                    cardTitle="Cloud Solutions Leveraging Firebase"
                    cardPara="We employ and integrate an API that enables seamless synchronization of application data across multiple clients, storing it within Firebase's cloud infrastructure."
                    cardLink=""
                    btnName="Order an estimate"
                  />
                </div>
                <div className="slide-item">
                  <HealthSliderCard
                    cardTitle="Seamless Integration with Firebase"
                    cardPara="We seamlessly integrate Firebase with diverse platforms such as AdWords, AdMob, Play Store, Data Studio, Slack, and Jira to fulfill a range of unique requirements."
                    cardLink=""
                    btnName="Share your idea"
                  />
                </div>
                <div className="slide-item">
                  <HealthSliderCard
                    cardTitle="Firebase Advisory Services"
                    cardPara="Engage proficient Firebase developers who offer expert consulting services characterized by efficiency and swift response, ensuring prompt resolution of existing backend issues."
                    cardLink=""
                    btnName="Get consultation"
                  />
                </div>
                <div className="slide-item">
                  <HealthSliderCard
                    cardTitle="Cloud Firestore Database"
                    cardPara="We utilize Cloud Firestore to enhance Android, iOS, and web applications, making them more robust, secure, and scalable compared to traditional real-time databases."
                    cardLink=""
                    btnName="Share your idea"
                  />
                </div>
              </Slider>
            </div>
          </div>
        </div>
        <section className="DevservicesBlocks">
          <DevServicesBlocks />
        </section>
        <section className="whatMakesSection" id="whatMakesSection">
          <DevDiff
            float1={float1}
            float2={float2}
            Char1="What Makes"
            Char2="us"
            Char3="Different?"
            diffDescription="What sets us apart is our expertise, customization, collaboration, creativity, results-driven approach, and customer-centric focus. We have a highly skilled team, personalized solutions, open communication, innovative ideas, a focus on measurable results, and a dedication to customer satisfaction. These factors combine to deliver outstanding outcomes and exceptional experiences for our clients."
          />
        </section>
        <section id="case_study" className="case_study devCaseStudy">
          <CaseStudyNew
            titleChar1="Our"
            titleChar2="Work"
            projectTitle10="1. Utsav Jewels"
            projectPara11="Utssav Jwelles had a strong presence in the offline market but wanted to expand their reach to a wider audience by selling their products online. They approached us at Version Next to help them needed a user-friendly e-commerce website that provided a seamless shopping experience to their customers."
            projectPara12="To address Utssav Jwelles' requirements, we designed and developed an e-commerce with mobile app for Utssav Jwelles to manage their orders and deliveries. The app allowed them to view all orders and track their status in real-time. The application was built using a modern stack of technologies to ensure fast loading times and smooth checkout processes."
            projectPara13="At Version Next, we take pride in delivering high-quality solutions that are tailored to our client's business needs. Our collaboration with Utssav Jwelles is an example of how we leverage our expertise in web and mobile app development to help businesses achieve their goals."
            projectTitle20="2. Building an ERP Tool for Heritage"
            projectPara21="Heritage, a leading company in the industry, sought to enhance their customer experience by developing an ERP tool. This tool aimed to seamlessly connect customers with the ability to order subscription-based products through their app. Additionally, it would establish a connection to the nearest Heritage branch responsible for fulfilling the orders and facilitating timely deliveries. Version Next, an experienced IT services provider, was enlisted to build this innovative solution."
            projectPara22="Version Next's development team meticulously crafted the ERP tool, leveraging industry-standard technologies to ensure a robust and reliable solution. The user interface was designed with a customer-centric approach, focusing on simplicity and ease of use while offering a comprehensive ordering experience. The ERP tool transformed Heritage's customer experience by providing a convenient, user-friendly platform for ordering subscription-based products."
            projectPara23="The solution provided Heritage with a competitive edge by enhancing customer satisfaction, optimizing internal operations, and supporting future growth."
            projectTitle30="3. Parental Control App for MobiCID"
            projectPara31="MobiCID,has the goal was to create a powerful tool that would enable parents to monitor and manage their children's online activities effectively, approached Version Next with a specific requirement."
            projectPara32="Version Next collaborated closely with MobiCID to understand their specific needs and the desired functionalities of the parental control app. We implemented advanced tracking mechanisms to capture and present detailed reports on calling, app usage, websites visited, and social media interactions. The app provided parents with extensive customization options, allowing them to set screen time limits, block specific apps or websites, and receive notifications for concerning activities."
            projectPara33="The implementation of stringent privacy and security measures further enhanced the app's reliability and trustworthiness. Overall, the MobiCID parental control app became a valuable tool for proactive parental oversight in today's digital age."
            projectTitle40="4. Mobile Trading App for Elixir Equities"
            projectPara41="Elixir Equities, a prominent financial services company, approached our team with a specific requirement: to design and develop a mobile trading app that would enable their clients to engage in seamless trading activities using their API."
            projectPara42="We collaborated closely with Elixir Equities to understand their specific needs and the desired functionalities of the mobile trading app. We developed a robust backend system that seamlessly integrated with Elixir Equities' API, allowing real-time market data updates and immediate trade execution. The app was equipped with a wide range of trading features, including market orders, limit orders, real-time portfolio tracking, and historical trade data analysis."
            projectPara43="By providing an intuitive UI/UX design, seamless integration with the Elixir Equities API, and a wide range of trading features, the app revolutionised the trading experience for their clients. With a strong emphasis on security and compliance, the app offered peace of mind to users, knowing their information and transactions were protected."
            totlaCount="4"
          />
        </section>
        <section className="IndusExpertSection">
          <IndusExpert
            cName="Version Next Technologies"
            cSecTitle="Why Hire Version Next Technologies as Firebase Services"
            profileName="Mr. Sanyogg Shelar"
            designation="Buisness Head"
            cardTitle1="Expert Firebase Developers"
            cardData1="Our skilled team of Firebase developers brings extensive experience and proficiency to deliver top-notch solutions."
            cardTitle2="Comprehensive Solutions"
            cardData2="We offer end-to-end Firebase services, encompassing development, integration, optimization, and ongoing support."
            cardTitle3="Custom Solutions"
            cardData3="Our tailored Firebase solutions are designed to fit your unique business needs, providing the flexibility to scale as you grow."
            cardTitle4="Real-time Sync"
            cardData4="We leverage Firebase's real-time data synchronization capabilities to create applications that deliver responsive and dynamic user experiences."
            profileImg={sanyogprofileImg}
            facebookLink="https://profiles.wordpress.org/codexdemon/"
            facebookIcon="fab fa-wordpress"
            twiiterLink="https://twitter.com/sanyog"
            twitterIcon="fab fa-twitter-square"
            linkdinLink="https://www.linkedin.com/in/sanyogs"
            linkdinIcon="fab fa-linkedin"
          />
        </section>
        <section className="commonFaq d-none">
          <div className="container">
            <div className="sectionTitle">
              <h2>
                Frequently Asked <span className="textGrade">Questions</span>
              </h2>

              <p>
                Singling out common points and possible difficulties which can
                be encountered in EHR, EMR, and Patient Portal software
                development
              </p>
            </div>
            <div className="row">
              <div className="col-md-12 col-lg-6 col-12">
                <Accodion />
              </div>
              <div className="col-md-12 col-lg-6 col-12">
                <FaqVideo />
              </div>
            </div>
            <div className="readMoreBtnWrap">
              <TransparentRoundedBtn
                rText="Read More"
                rLink="/faqs"
                rName="rAnimeBtn readMoretBtn"
              />
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default FirebaseDev;
